import React, { useRef } from 'react';
import Slider, { Settings } from 'react-slick';

import classes from './ProductSlider.module.scss';

type ProductSliderProps = {
    settings: Settings;
    children?: React.ReactNode;
};

function NextArrow(props) {
    const { className, onClick } = props;
    const isDisabled = className.includes('slick-disabled');

    return (
        <button
            type="button"
            aria-label="Click to go to the next slide"
            className={className}
            onClick={onClick}
            disabled={isDisabled}
        />
    );
}

function PrevArrow(props) {
    const { className, onClick } = props;
    const isDisabled = className.includes('slick-disabled');

    return (
        <button
            type="button"
            aria-label="Click to go to the previous slide"
            className={className}
            onClick={onClick}
            disabled={isDisabled}
        />
    );
}

export function ProductSlider(props: ProductSliderProps) {
    const sliderRef = useRef<Slider>(null);

    /**
     * Gallery setting for slick slider
     */
    const settings: Settings = {
        accessibility: true,
        className: classes['slider'],
        draggable: false,
        pauseOnHover: true,
        responsive: [
            {
                breakpoint: 899,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                },
            },
        ],
        slidesToScroll: 1,
        slidesToShow: 4,
        speed: 400,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
        ...props.settings,
    };

    /**
     * Render the Row Block UI
     */
    return (
        <Slider ref={sliderRef} {...settings}>
            {props.children}
        </Slider>
    );
}
